module.exports = __webpack_public_path__ + "img/img-apple-store-download@2x.5fe25828.jpg";